export default {"src":"/_next/static/media/crowd-pleasers.729a8587.svg","height":13,"width":14};